/*
 * Public API Surface of streaming
 */

export * from './streaming.service';
export * from './plugin-initializer';
